import React from 'react';

import { fpga as fpgaIcon} from '@images/logos-techstack';

export const fpga = {
  mainSection: {
    icon: fpgaIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            A Field Programmable Gate Array (FPGA) is a programmable integrated circuit that can be programmed for a
            specific use after it has been manufactured.
          </>,
          <></>,
          <>
            FPGAs are more flexible than standard ASIC-s (Application Specific Integrated Circuits) such as CPUs and
            GPUs, which are not customizable.
          </>,
          <></>,
          <>
            FPGAs are used in many markets: data centers, medical devices, image and video processing, high-performance
            computing and data storage, to name a few.
          </>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        description: 'Our FPGA-related services include:',
        items: [
          <>IP Cores integration and development (VHDL)</>,
          <>HW simulation (e.g. using Active-HDL, ModelSim)</>,
          <>Smoke tests executed directly on hardware</>,
          <>API level tests of hardware designs</>,
          <>
            Building full, system-level, dynamic acceptance tests alongside a complete virtual environment reflecting
            the end user’s use cases
          </>,
          <>
            Building full CI/CD pipelines and verifying the hardware design in a continuous mode with full visibility
            for developers, QA and managers (domain, software and hardware knowledge on board)
          </>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Blog post',
        items: [
          {
            title: 'FPGA programming—how it works and where it can be used',
            link: '/blog/fpga-programming/',
          },
        ],
      },
    ],
  },
};
